import { getCustomHeaders } from '@/components/marketing-landing-page/utils';
import { LoginEventMetadata } from '@/types/login-event-metadata';
import { getLocalStorageValue } from '@/utils/utils';
import apiClient from '@admin/lib/auth.client';

const baseUrl = process.env.NEXT_PUBLIC_API_BASE_URL_AUTH;
const cjrBaseUrl = process.env.NEXT_PUBLIC_CJR_API_BASE_URL;

export const logout = async (): Promise<any> => {
  return await apiClient.post(`${baseUrl}/v1/oauth/logout`, {});
};

export const generateOtp = async ({
  username,
  countryCode,
  organizationId,
  smsType = 0,
}: {
  username: string;
  countryCode: string;
  organizationId: string;
  smsType?: number;
}): Promise<any> => {
  const data = {
    username,
    countryCode,
    organizationId,
  };

  const customHeaders = getCustomHeaders({ org: 'CJR' });

  return await apiClient.post(`${baseUrl}/v1/users/get-otp?smsType=${smsType}`, data, {
    customHeaders,
  });
};

export const handleFreeEnroll = async (batchId: string) => {
  const customHeaders = getCustomHeaders({ org: 'CJR' });
  return await apiClient.get(`${baseUrl}/v1/batches/${batchId}/enroll-student`, {
    public: false,
    customHeaders,
  });
};

export const handleFreeEnrollCJR = async (batchId: string, meta: {}, extendedParams: {}) => {
  const customHeaders = getCustomHeaders({ org: 'CJR' });
  return await apiClient.post(
    `${baseUrl}/v3/batch-service/batch-student/${batchId}/enroll-student`,
    {
      meta,
      extendedParams,
    },
    { public: false, customHeaders }
  );
};

export const checkUserExist = async (phone: string) => {
  const customHeaders = getCustomHeaders({ org: 'CJR' });
  try {
    const data = {
      username: phone,
      organizationId: process.env.NEXT_PUBLIC_CURIOUSJR_ORG_ID,
    };

    return await apiClient.post(
      `${process.env.NEXT_PUBLIC_API_BASE_URL_AUTH}/v3/users/public/trigger-flow`,
      data,
      { customHeaders }
    );
  } catch (error) {
    console.log('Error checking user existence:', error);
    return null;
  }
};
export const handleOtplessVerifyToken = async (
  response: any,
  utm_source?: string,
  utm_medium?: string,
  utm_campaign?: string,
  deviceManufacturer?: string,
  pageType?: string,
  mlpName?: string,
  mlpType?: string
) => {
  const customHeaders = getCustomHeaders({ org: 'CJR' });
  return await apiClient.post(
    `${process.env.NEXT_PUBLIC_API_BASE_URL_AUTH}/v3/oauth/public/otpless-verify-token`,
    {
      token: response.token,
      organizationId: process.env.NEXT_PUBLIC_CURIOUSJR_ORG_ID,
      firstName: '',
      utm_source,
      utm_medium,
      utm_campaign,
      device: deviceManufacturer,
      pageType,
      mlpName,
      mlpType,
    },
    { customHeaders }
  );
};

export const handleRegister = async ({
  mobile,
  firstName,
  lastName,
  countryCode,
  smsType = 0,
  loginEventMetadata,
}: {
  mobile: string;
  firstName?: string;
  lastName?: string;
  countryCode?: string;
  smsType?: Number;
  loginEventMetadata?: LoginEventMetadata;
}): Promise<any> => {
  const data = {
    mobile,
    firstName: firstName || '',
    lastName: lastName || '',
    countryCode: countryCode || '+91',
    ...(loginEventMetadata && { loginEventMetadata }),
  };

  const customHeaders = getCustomHeaders({ org: 'CJR' });

  return await apiClient.post(
    `${baseUrl}/v1/users/register/${process.env.NEXT_PUBLIC_CURIOUSJR_ORG_ID}?smsType=${smsType}`,
    data,
    { customHeaders }
  );
};

export const verifyOtp = async ({
  username,
  otp,
  utm_source,
  utm_medium,
  utm_campaign,
  device,
  location,
  pageType,
  mlpName,
  mlpType,
  loginEventMetadata,
}: {
  username: string;
  otp: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  device?: string;
  location?: string;
  pageType?: string;
  mlpName?: string;
  mlpType?: string;
  loginEventMetadata?: LoginEventMetadata;
}): Promise<any> => {
  const data = {
    otp: otp,
    client_id: 'system-admin',
    organizationId: process.env.NEXT_PUBLIC_CURIOUSJR_ORG_ID as string,
    username,
    ...(utm_source && { utm_source }),
    ...(utm_medium && { utm_medium }),
    ...(utm_campaign && { utm_campaign }),
    ...(device && { device }),
    ...(location && { location }),
    ...(pageType && { pageType }),
    ...(mlpName && { mlpName }),
    ...(mlpType && { mlpType }),
    ...(loginEventMetadata && { loginEventMetadata }),
  };
  const customHeaders = getCustomHeaders({ org: 'CJR' });

  const resp = await apiClient.post(`${baseUrl}/v3/oauth/token`, data, { customHeaders });

  return resp;
};

export const getMe = async (): Promise<any> => {
  const customHeaders = getCustomHeaders({ org: 'CJR' });
  const resp = await apiClient.get(`${baseUrl}/v1/users/self`, { public: false, customHeaders });

  localStorage.setItem('user', JSON.stringify((resp as any)?.data));
};

export const getBatchDetails = async ({ batchId }: { batchId: string }): Promise<any> => {
  const customHeaders = getCustomHeaders({ org: 'CJR' });
  return await apiClient.get(`${baseUrl}/v3/batches/${batchId}/details`, {
    public: false,
    customHeaders,
  });
};

export const updateCohort = async ({
  cohortId,
  class: classValue,
}: {
  cohortId: string;
  class?: string;
}): Promise<any> => {
  const data: { cohortId: string; class?: string } = {
    cohortId,
  };
  if (classValue) {
    data.class = classValue;
  }

  const customHeaders = getCustomHeaders({ org: 'CJR' });

  return await apiClient.put(`${baseUrl}/v1/users/update-cohort`, data, { customHeaders });
};

export const updateRecentCohort = async ({ cohortId }: { cohortId: string }): Promise<any> => {
  const data = {
    cohortId,
  };

  const customHeaders = getCustomHeaders({ org: 'CJR' });

  console.log('custome header', customHeaders);

  return await apiClient.put(`${baseUrl}/v1/users/update-recent-cohort`, data, { customHeaders });
};

export const updatePwUser = async ({ grade }: { grade: string }): Promise<any> => {
  const data = {
    class: grade,
  };
  const customHeaders = getCustomHeaders({ org: 'CJR' });

  return await apiClient.put(`${baseUrl}/v1/users`, data, { customHeaders });
};

export const createCjrUser = async ({
  grade,
  deviceManufacturer,
  deviceModel,
  deviceOS,
  deviceBrowser,
}: {
  grade: string;
  deviceManufacturer: string;
  deviceModel: string;
  deviceOS: string;
  deviceBrowser: string;
}): Promise<any> => {
  const data = {
    grade,
  };

  const headers = {
    'x-request-source': 'MLP',
    'x-request-platform': 'WEB',
    'x-device-manufacturer': deviceManufacturer,
    'x-device-model': deviceModel,
    'x-device-os': deviceOS,
    'x-device-browser': deviceBrowser,
    'x-request-source-link': window?.location?.href || '',
  };

  return await apiClient.put(`${baseUrl}/v1/users`, data, { customHeaders: headers });
};

export const verifyToken = async (shouldNotRedirect?: boolean): Promise<VerifyTokenResponse> => {
  const customHeaders = getCustomHeaders({ org: 'CJR' });
  return await apiClient.post<VerifyTokenResponse, unknown>(
    `${baseUrl}/v3/oauth/verify-token`,
    {
      organizationId: process.env.NEXT_PUBLIC_CURIOUSJR_ORG_ID,
      randomId: getLocalStorageValue('randomId'),
    },
    { customHeaders, shouldNotRedirect }
  );
};

export const getPlans = async (batchId: string) => {
  const customHeaders = getCustomHeaders({ org: 'CJR' });
  return apiClient.get<{ data: any }, unknown>(`${baseUrl}/v1/batches/${batchId}/plans`, {
    customHeaders,
  });
};

export const getFeeId = async (batchId: string, data: any) => {
  const customHeaders = getCustomHeaders({ org: 'CJR' });
  return apiClient.post<{ data: any }, unknown>(
    `${baseUrl}/v1/batches/${batchId}/get-fee-id`,
    data,
    {
      customHeaders,
    }
  );
};

export const getPaymentInfo = () => {
  const customHeaders = getCustomHeaders({ org: 'CJR' });
  return apiClient.get<{ data: any }, unknown>(
    `${baseUrl}/v1/organizations/${process.env.NEXT_PUBLIC_CURIOUSJR_ORG_ID}/payment-info`,
    { customHeaders }
  );
};

export const orderStatus = async (orderId: string) => {
  const customHeaders = getCustomHeaders({ org: 'CJR' });
  return apiClient.get<{ data: any }, unknown>(`${baseUrl}/v1/orders/${orderId}/status`, {
    customHeaders,
  });
};

export const createOrder = async (data: any) => {
  const customHeaders = getCustomHeaders({ org: 'CJR' });
  return apiClient.post<{ data: any }, unknown>(`${baseUrl}/v1/orders`, data, { customHeaders });
};

export const batchPurchaseCancelComms = (batchId: string) => {
  const customHeaders = getCustomHeaders({ org: 'CJR' });
  return apiClient.post<{ data: any }, unknown>(
    `${cjrBaseUrl}/v1/user/communication/type/BATCH_PURCHASE_CANCEL?batchId=${batchId}`,
    {},
    {
      customHeaders,
    }
  );
};

export enum PaymentStatus {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILED',
  PENDING = 'PENDING',
  PENDING_VBV = 'PENDING_VBV',
  REQUESTED = 'REQUESTED',
}

export type PAYMENT_SOURCE = 'RAZOR_PAY' | 'STRIPE';

export type VerifyTokenResponse = {
  data: {
    isVerified: boolean;
  };
  success: boolean;
};
